<template>
    <div>
        <!--面包屑-->
        <breadcrumb-link :title="getTitle"></breadcrumb-link>
        <!--内容区域-->
        <div>
            <el-form class="box-detail" label-width="130px" ref="detail" :inline="true" :model="detail" :disabled="getDisabled">
                <div class="edit-title">基础信息</div>

                <el-form-item label="Sink名称" label-width="220px" prop="name" :rules="[{required: true, message: '必填，不超过50个字符', trigger: 'blur'}]">
                    <el-col :span="24">
                        <el-input class="main-input" placeholder="必填，不超过50个字符" maxlength="50" show-word-limit v-model="detail.name"></el-input>
                    </el-col>
                </el-form-item>

                <div class="edit-title">字段信息</div>
                <el-form-item label="sink类型:" label-width="220px" prop="sinkType" :rules="[{required: true, message: '必填'}]">
                    <el-select v-model="detail.sinkType" :disabled="getSelectDisabled" placeholder="请选择">
                        <el-option label="File" value="File"></el-option>
                        <el-option label="Kafka" value="Kafka"></el-option>
                    </el-select>
                </el-form-item>

                <div v-if="detail.sinkType == 'File' && detail.pipelineFileSinkVO">
                    <el-form-item label="数据文件储存路径:" label-width="220px" prop="pipelineFileSinkVO.fileStorePath" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入数据文件储存路径" style="width:600px" v-model="detail.pipelineFileSinkVO.fileStorePath"></el-input>
                    </el-form-item>
                    <el-form-item label="FileChannel使用的buffer容量:" label-width="220px" prop="pipelineFileSinkVO.bufferSize" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入FileChannel使用的buffer容量" style="width:200px" v-model="detail.pipelineFileSinkVO.bufferSize"></el-input>
                    </el-form-item>
                    <el-form-item label="未发送数据的储存路径:" label-width="220px" prop="pipelineFileSinkVO.unsendDataStorePath" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入未发送数据的储存路径" style="width:600px" v-model="detail.pipelineFileSinkVO.unsendDataStorePath"></el-input>
                    </el-form-item>
                </div>

                <div v-if="detail.sinkType == 'Kafka' && detail.pipelineKafkaSinkVO">
                    <el-form-item label="选择Kafka集群:" label-width="220px" prop="pipelineKafkaSinkVO.kafkaId" :rules="[{required: true, message: '必填'}]">
                        <el-select filterable v-model="detail.pipelineKafkaSinkVO.kafkaId" :disabled="getSelectDisabled" placeholder="请选择" value-key="id">
                            <el-option v-for="(itm, idx) in kafkaList" :key="idx" :label="itm.name" :value="itm.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="ACK:" label-width="220px" prop="pipelineKafkaSinkVO.ack" :rules="[{required: true, message: '必填'}]">
                        <el-select v-model="detail.pipelineKafkaSinkVO.ack" placeholder="请选择">
                            <el-option label="-1" value="-1"></el-option>
                            <el-option label="0" value="0"></el-option>
                            <el-option label="1" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="生产者缓存大小:" label-width="220px" prop="pipelineKafkaSinkVO.bufferMemory" :rules="[{required: true, message: '必填'}]">
                        <el-input type="number" placeholder="请输入生产者缓存大小" style="width:193px" v-model="detail.pipelineKafkaSinkVO.bufferMemory"></el-input>
                    </el-form-item>
                    <el-form-item label="压缩算法名称:" label-width="220px" prop="pipelineKafkaSinkVO.compressType" :rules="[{required: true, message: '必填'}]">
                        <el-select v-model="detail.pipelineKafkaSinkVO.compressType" placeholder="请选择">
                            <el-option label="lz4" value="lz4"></el-option>
                            <el-option label="gzip" value="gzip"></el-option>
                            <el-option label="snappy" value="snappy"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="批次大小:" label-width="220px" prop="pipelineKafkaSinkVO.batchSize" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入批次大小" style="width:193px" v-model="detail.pipelineKafkaSinkVO.batchSize"></el-input>
                    </el-form-item>
                    <el-form-item label="发送间隔:" label-width="220px" prop="pipelineKafkaSinkVO.lingerMs" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入发送间隔" style="width:193px" v-model="detail.pipelineKafkaSinkVO.lingerMs"></el-input>
                    </el-form-item>
                    <el-form-item label="单批次发送字节数上限:" label-width="220px" prop="pipelineKafkaSinkVO.maxRequestSize" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入单批次发送字节数上限" style="width:193px" v-model="detail.pipelineKafkaSinkVO.maxRequestSize"></el-input>
                    </el-form-item>
                    <el-form-item label="发送超时时间:" label-width="220px" prop="pipelineKafkaSinkVO.requestTimeout" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入发送超时时间" style="width:193px" v-model="detail.pipelineKafkaSinkVO.requestTimeout"><i slot="suffix">MS</i></el-input>
                    </el-form-item>
                    <el-form-item label="从节点响应超时时间:" label-width="220px" prop="pipelineKafkaSinkVO.followerTimeout" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入从节点响应超时时间" style="width:193px" v-model="detail.pipelineKafkaSinkVO.followerTimeout"><i slot="suffix">MS</i></el-input>
                    </el-form-item>
                    <el-form-item label="发送重试次数:" label-width="220px" prop="pipelineKafkaSinkVO.retries" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入发送重试次数" style="width:193px" v-model="detail.pipelineKafkaSinkVO.retries"></el-input>
                    </el-form-item>
                    <el-form-item label="并行发送批次限制:" label-width="220px" prop="pipelineKafkaSinkVO.maxInFlight" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入并行发送批次限制" style="width:193px" v-model="detail.pipelineKafkaSinkVO.maxInFlight"></el-input>
                    </el-form-item>
                    <el-form-item label="发送失败数据储存路径:" label-width="220px" prop="pipelineKafkaSinkVO.errorDataStorePath" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入发送失败数据储存路径" style="width:193px" v-model="detail.pipelineKafkaSinkVO.errorDataStorePath"></el-input>
                    </el-form-item>
                    <el-form-item label="未发送数据储存路径:" label-width="220px" prop="pipelineKafkaSinkVO.unsendDataStorePath" :rules="[{required: true, message: '必填'}]">
                        <el-input placeholder="请输入未发送数据储存路径" style="width:193px" v-model="detail.pipelineKafkaSinkVO.unsendDataStorePath"></el-input>
                    </el-form-item>
                </div>
                <div v-if=" type == 'details' ">
                    <history-record :historyTitle="historyTitle" :historyList="historyList" />
                </div>
            </el-form>
            <div style="padding-left: 130px">
                <el-button type="primary" @click="submitForm('detail')" v-if="type!='details'">保存
                </el-button>
                <el-button type="info" plain @click="goBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import BreadcrumbLink from "../../../components/breadcrumbLink";
import util from "@/utils/util";
import HistoryRecord from "../../../components/common/historyRecord";
import {
    getSinkInfo,
    getKafkaList,
    addSink,
    editSink
} from "@/apis/pipelineService/pipelineConfig";

export default {
    components: {
        HistoryRecord,
        BreadcrumbLink
    },
    data() {
        return {
            type: "", // 跳转页面获取标题
            kafkaList: [],
            detail: {
                name: "", // pipeline名称
                sinkType: "",
                pipelineFileSinkVO: {
                    bufferSize: "1048576",
                    fileStorePath: "",
                    unsendDataStorePath: ""
                },
                pipelineKafkaSinkVO: {
                    ack: "-1",
                    batchSize: 16384,
                    kafkaId: null,
                    bufferMemory: 33554432,
                    compressType: "lz4",
                    errorDataStorePath: "",
                    followerTimeout: 30000,
                    maxInFlight: 5,
                    maxRequestSize: 1048576,
                    requestTimeout: 30000,
                    retries: 3,
                    unsendDataStorePath: "",
                    lingerMs: 200
                }
            },

            setOptions: {},
            historyTitle: "记录信息", // 记录信息标题
            historyList: [], // 记录信息信息内容

            id: this.$route.query.id,
            sinkType: this.$route.query.sinkType
        };
    },
    computed: {
        getDisabled() {
            return {
                add: false,
                edit: false,
                details: true
            }[this.type];
        },
        getSelectDisabled() {
            return {
                add: false,
                edit: true,
                details: true
            }[this.type];
        },
        getTitle() {
            return {
                add: "新增Sink配置",
                edit: "修改Sink配置",
                details: "Sink配置详情"
            }[this.type];
        }
    },
    mounted() {
        this.type = this.$route.query.type;
        this.getKafkaList();
        if (this.type != "add") this.getDetails();
    },
    methods: {
        async getKafkaList() {
            let params = {
                current: 1,
                size: 100
            };
            try {
                const data = await getKafkaList(params);
                if (data.code == 0 && data.data) {
                    this.kafkaList = data.data.records;
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        },
        // 返回上一层
        goBack() {
            this.$router.go(-1);
        },
        // 详情
        async getDetails() {
            let params = {
                id: this.id,
                sinkType: this.sinkType
            };
            try {
                const data = await getSinkInfo(params);
                if (data.code == 0 && data.data) {
                    this.detail = data.data;
                    this.historyList = [
                        {
                            label: "创建人：",
                            value: data.data.creatorName
                        },
                        {
                            label: "创建时间：",
                            value: data.data.createTime.replace(/T/g,' '),
                        },
                        {
                            label: "最后修改人：",
                            value: data.data.updatorName
                        },
                        {
                            label: "修改时间：",
                            value: data.data.updateTime.replace(/T/g,' '),
                        }
                    ];
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.pushForm();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 提交
        async pushForm() {
            let params = {
                ...this.detail
            };

            if (this.type == "add") {
                delete params.id;
            }
            try {
                const data =
                    this.type == "add"
                        ? await addSink(params)
                        : await editSink(params);
                if (data.code == 0) {
                    this.$router.go(-1);
                    this.$message.success(data.message);
                } else {
                    this.$message.error(data.message);
                }
            } catch (error) {}
        }
    }
};
</script>

<style scoped lang="scss">
.box-detail {
    width: 850px;
    .main-input {
        width: 400px;
    }
}
</style>
